var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.856,
    height: 21.295,
    viewBox: "0 0 23.856 21.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(0.299 -27.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_73",
    "data-name": "Grupo 73",
    transform: "translate(-0.001 27.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_72",
    "data-name": "Grupo 72",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57",
    "data-name": "Trazado 57",
    d: "M23.058,36,12.01,27.914a.605.605,0,0,0-.715,0L.247,36a.606.606,0,1,0,.715.977l10.69-7.827,10.69,7.827A.606.606,0,0,0,23.058,36Z",
    transform: "translate(0.001 -27.797)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_75",
    "data-name": "Grupo 75",
    transform: "translate(2.569 37.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74",
    "data-name": "Grupo 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_58",
    "data-name": "Trazado 58",
    d: "M74.013,232.543a.606.606,0,0,0-.606.606v9.639H68.564v-5.262a3.028,3.028,0,1,0-6.056,0v5.262H57.663v-9.639a.606.606,0,1,0-1.211,0v10.244a.606.606,0,0,0,.606.606h6.056a.605.605,0,0,0,.6-.558.457.457,0,0,0,0-.047v-5.867a1.817,1.817,0,0,1,3.634,0v5.867a.444.444,0,0,0,0,.047.605.605,0,0,0,.6.559h6.056a.606.606,0,0,0,.606-.606V233.149A.606.606,0,0,0,74.013,232.543Z",
    transform: "translate(-56.452 -232.543)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c76cb4ff157cbe04dbbae3e3e24c9696.svg";
export { ForwardRef as ReactComponent };